/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type featuredListCollectionQueryVariables = {
    readonly id: string;
};
export type featuredListCollectionQueryResponse = {
    readonly listCollection: {
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly listCollection: {
            readonly __typename: string;
            readonly description: string | null;
            readonly id: string;
            readonly label: string | null;
            readonly badges: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly kind: PreviewKind | null;
                            readonly mediaAsset: {
                                readonly files: ReadonlyArray<{
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly previews: {
                readonly edges: ReadonlyArray<{
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                    } | null;
                }> | null;
            } | null;
            readonly name: string | null;
            readonly subTitle: string | null;
            readonly title: string | null;
            readonly revision: string | null;
        } | null;
    } | null;
};
export type featuredListCollectionQuery = {
    readonly response: featuredListCollectionQueryResponse;
    readonly variables: featuredListCollectionQueryVariables;
};



/*
query featuredListCollectionQuery(
  $id: ID!
) {
  listCollection(id: $id) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    listCollection {
      __typename
      description
      id
      label
      badges {
        imageLink
        link
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                files {
                  name
                  path
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
                id
              }
            }
          }
        }
        id
      }
      previews {
        edges {
          preview {
            mediaAsset {
              id
              files {
                name
                path
                id
              }
              topLevelMediaType {
                kind
                id
              }
            }
            link
            kind
          }
        }
      }
      name
      subTitle
      title
      revision
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "created",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageLink",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v12/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/),
    (v2/*: any*/)
  ]
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v2/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "featuredListCollectionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "badges",
                "storageKey": null,
                "args": null,
                "concreteType": "Badge",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaAsset",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaAsset",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "previews",
                "storageKey": null,
                "args": null,
                "concreteType": "PreviewsConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preview",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Preview",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "featuredListCollectionQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "badges",
                "storageKey": null,
                "args": null,
                "concreteType": "Badge",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaAsset",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaAsset",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "previews",
                "storageKey": null,
                "args": null,
                "concreteType": "PreviewsConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preview",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Preview",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "featuredListCollectionQuery",
    "id": null,
    "text": "query featuredListCollectionQuery(\n  $id: ID!\n) {\n  listCollection(id: $id) {\n    errors {\n      created\n      id\n      location\n      type\n    }\n    hasErrors\n    listCollection {\n      __typename\n      description\n      id\n      label\n      badges {\n        imageLink\n        link\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              link\n              kind\n              mediaAsset {\n                files {\n                  name\n                  path\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n                id\n              }\n            }\n          }\n        }\n        id\n      }\n      previews {\n        edges {\n          preview {\n            mediaAsset {\n              id\n              files {\n                name\n                path\n                id\n              }\n              topLevelMediaType {\n                kind\n                id\n              }\n            }\n            link\n            kind\n          }\n        }\n      }\n      name\n      subTitle\n      title\n      revision\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2d94985ba889d69fb99b07a1646caee3';
export default node;
